module.exports = __webpack_public_path__ + "img/transfer.75c17294.svg";